<template>
  <div class="container mx-auto px-4 h-full">
    <div class="flex content-center items-center justify-center h-full">
      <div class="w-full lg:w-6/12 px-4">
        <div
          class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0"
        >
          <div
            v-if="showTestRedirectToggle"
            class="px-4 lg:px-10 pt-6 pb-2 border-b border-blueGray-100 bg-blueGray-50 rounded-t-lg"
          >
            <div class="flex items-start justify-between gap-4">
              <div>
                <div class="text-sm font-semibold text-blueGray-700">测试环境登录开关</div>
                <p class="text-xs text-blueGray-500 mt-1">
                  当前：{{ testRedirectEnabled ? "测试环境" : "线上环境" }}。开启后登录及接口全部走测试环境，关闭后全部走线上环境。
                </p>
                <p v-if="testRedirectEnabled" class="text-xs text-blueGray-500 mt-1">
                  登录回跳地址：{{ testRedirectTarget }}
                </p>
              </div>
              <button
                type="button"
                class="px-3 py-1 text-xs font-semibold rounded border"
                :class="testRedirectEnabled ? 'bg-emerald-500 text-white border-emerald-500' : 'bg-white text-blueGray-600 border-blueGray-200'"
                @click="toggleTestRedirect"
              >
                {{ testRedirectEnabled ? "已开启" : "未开启" }}
              </button>
            </div>
          </div>

          <!-- WeCom QR Code Login -->
          <div v-if="showWeComLogin" class="flex-auto px-4 lg:px-10 py-10 pt-0">
            <WeComLogin class="mb-6"/>
          </div>

          <!-- Traditional Login Form -->

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import WeComLogin from "@/components/WeComLogin.vue";

const WECOM_TEST_REDIRECT_KEY = "wecom_test_redirect";
const DEFAULT_TEST_CALLBACK_URL =
  process.env.VUE_APP_WECOM_TEST_CALLBACK_URL || "";

function getDefaultTestCallbackUrl() {
  if (DEFAULT_TEST_CALLBACK_URL) {
    return DEFAULT_TEST_CALLBACK_URL;
  }
  if (typeof window === "undefined") {
    return "http://localhost:8080/auth/wxauth";
  }
  return `${window.location.origin}/auth/wxauth`;
}

export default {
  components: {
    WeComLogin
  },
  data() {
    return {
      showTestRedirectToggle: process.env.NODE_ENV !== 'production',
      testRedirectEnabled: false,
      testRedirectTarget: "",
      showWeComLogin: true, // 默认显示企业微信登录
      form: {
        email: '',
        password: '',
        rememberMe: false
      },
      isLoading: false,
      errorMessage: ''
    };
  }
  ,
  mounted() {
    this.syncTestRedirectState();
  },
  methods: {
    syncTestRedirectState() {
      const testCallbackUrl = getDefaultTestCallbackUrl();
      const storedValue = window.localStorage.getItem(WECOM_TEST_REDIRECT_KEY) || "";
      if (storedValue && storedValue !== testCallbackUrl) {
        window.localStorage.setItem(WECOM_TEST_REDIRECT_KEY, testCallbackUrl);
      }
      const testRedirectTarget = storedValue ? testCallbackUrl : "";
      this.testRedirectEnabled = Boolean(testRedirectTarget);
      this.testRedirectTarget = testRedirectTarget || testCallbackUrl;
    },
    toggleTestRedirect() {
      const testCallbackUrl = getDefaultTestCallbackUrl();
      if (this.testRedirectEnabled) {
        window.localStorage.removeItem(WECOM_TEST_REDIRECT_KEY);
      } else {
        window.localStorage.setItem(WECOM_TEST_REDIRECT_KEY, testCallbackUrl);
      }
      this.syncTestRedirectState();
    },
  },
};
</script>
